<template>
  <v-app>
    <!-- 导航栏 -->
    <!-- 导航栏 -->
  <v-app-bar app color="indigo darken-2" dark>
    <v-toolbar-title class="font-weight-bold">高所作業車位置管理システム</v-toolbar-title>
    <v-spacer></v-spacer>

    <!-- 仅在小屏幕上显示导航图标 -->
    <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    
    <!-- 大屏幕显示按钮，使用 `v-show` 控制 -->
    <v-btn text href="#features" v-show="$vuetify.breakpoint.mdAndUp">特徴</v-btn>
    <v-btn text href="#specs" v-show="$vuetify.breakpoint.mdAndUp">仕様</v-btn>
    <v-btn text href="#applications" v-show="$vuetify.breakpoint.mdAndUp">利用例</v-btn>
    <v-btn text href="#testimonials" v-show="$vuetify.breakpoint.mdAndUp">お客様の声</v-btn>
    <v-btn text href="#contact" v-show="$vuetify.breakpoint.mdAndUp">お問い合わせ</v-btn>
    <v-btn text @click="sample_page = true" v-show="$vuetify.breakpoint.mdAndUp">デモ画面</v-btn>
  </v-app-bar>

  <!-- 抽屉导航，针对移动端 -->
  <v-navigation-drawer v-model="drawer" app temporary>
    <v-list>
      <v-list-item href="#features">特徴</v-list-item>
      <v-list-item href="#specs">仕様</v-list-item>
      <v-list-item href="#applications">利用例</v-list-item>
      <v-list-item href="#testimonials">お客様の声</v-list-item>
      <v-list-item href="#contact">お問い合わせ</v-list-item>
      <v-list-item @click="sample_page = true">デモ画面</v-list-item>
    </v-list>
  </v-navigation-drawer>

    <v-dialog v-model="sample_page" fullscreen transition="dialog-bottom-transition" persistent>
      <v-card>
        <Sample @close="sample_page = false"></Sample>
      </v-card>
    </v-dialog>

    <!-- 轮播图 -->
     <v-carousel
      :height="$vuetify.breakpoint.smAndDown ? '300px' : '600px'"
      hide-delimiter-background
      cycle
      interval="10000" 
    >
      <v-carousel-item
        v-for="(item, i) in carouselImages"
        :key="i"
      >
        <!-- 使用视频替代图片 -->
        <video
          :src="item.src"
          :type="item.type"
          autoplay
          muted
          loop
          playsinline
          class="carousel-video"
        ></video>

        <!-- 文字内容覆盖在视频上 -->
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" md="8" class="text-center">
              <h1 class="display-2 font-weight-bold white--text">{{ item.title }}</h1>
              <h2 class="headline white--text">{{ item.subtitle }}</h2>
            </v-col>
          </v-row>
        </v-container>
      </v-carousel-item>
    </v-carousel>

    <!-- 产品特点 -->
    <v-container id="features" class="py-12">
      <h2 class="text-center font-weight-bold mb-8">製品の特徴</h2>
      <v-row>
        <v-col cols="12" sm="6" md="4" v-for="(feature, index) in features" :key="index">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 12 : 2" class="mx-auto">
              <v-responsive aspect-ratio="16/9">
                <v-img :src="feature.image"></v-img>
              </v-responsive>
              <v-card-title class="font-weight-bold">{{ feature.title }}</v-card-title>
              <v-card-text>{{ feature.description }}</v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <!-- 产品规格 -->
    <v-container id="specs" class="py-12">
      <!-- 标题部分 -->
      <v-row class="mb-5">
        <v-col cols="12" class="text-center">
          <h2 class="display-2 font-weight-bold">製品仕様</h2>
        </v-col>
      </v-row>

      <!-- 产品规格和图片部分 -->
      <v-row>
        <!-- 产品规格列表 -->
        <v-col cols="12" md="6">
          <v-card outlined class="pa-3" style="height: 100%;">
            <v-list dense>
              <v-list-item v-for="(spec, index) in specs" :key="index">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{ spec.title }}</v-list-item-title>
                  <v-list-item-subtitle>{{ spec.value }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <!-- 产品图片 -->
        <v-col cols="12" md="6">
          <v-card outlined class="pa-3" style="height: 100%;">
            <v-responsive style="height: 100%; max-height: 400px;">
              <v-img
                src="../public/main_page/product.png"
                alt="製品仕様の画像"
                style="object-fit: contain; height: 100%;"
              ></v-img>
            </v-responsive>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- 利用例 -->
    <v-container id="applications" class="py-12">
      <!-- 标题部分 -->
      <v-row class="mb-5">
        <v-col cols="12" class="text-center">
          <h2 class="display-2 font-weight-bold">実際の利用例</h2>
        </v-col>
      </v-row>

      <!-- 大地图图片部分 -->
      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-responsive style="height: 100%; max-height: 500px;">
              <v-img
                src="../public/main_page/map.png"
                alt="地図の画像"
                style="object-fit: contain; width: 100%;"
              ></v-img>
            </v-responsive>
            <v-card-text class="text-center pt-4">
              <h2>利用済み・利用中の現場は十数所がありました、今後は更に増える見込みです。</h2>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    


    <v-carousel
    id="testimonials"
      :height="$vuetify.breakpoint.smAndDown ? '300px' : '600px'"
      hide-delimiter-background
      cycle
      interval="10000" 
    >
      <v-carousel-item
        v-for="(item, i) in carouselImages1"
        :key="i"
      >
        <!-- 使用视频替代图片 -->
        <video
          :src="item.src"
          :type="item.type"
          autoplay
          muted
          loop
          playsinline
          class="carousel-video"
        ></video>

        <!-- 文字内容覆盖在视频上 -->
        <v-container class="fill-height" fluid>

          <h1 class="display-2 font-weight-bold">お客様の声</h1>
           <v-row>
        <v-col cols="12" md="4" v-for="(testimonial, index) in testimonials" :key="index">
          <v-card  class="mx-auto"
  style="background: rgba(255, 255, 255, 0.7); box-shadow: none;">
            <v-card-title class="font-weight-bold">{{ testimonial.title }}</v-card-title>
            <v-card-text>"{{ testimonial.content }}"</v-card-text>
            <v-card-subtitle class="text-right font-italic">- {{ testimonial.author }}</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
        </v-container>
      </v-carousel-item>
    </v-carousel>





    

    <!-- お問い合わせ -->
    <v-container id="contact" class="py-12">
      <v-row>
        <!-- 左边列：制作和贩卖公司 -->
        <v-col cols="12" md="6">
          <v-card class="mx-auto mb-6" height="100%">
            <v-card-title class="font-weight-bold">開発･製造･販売 : 株式会社シーデックス</v-card-title>
            <v-row>
              <v-col cols="4">
                
                <v-img src="../public/main_page/company/cdex.png"
                  width="200px"
                  height="200px"
                  contain
                  @click="handleClick('https://www.cdex.co.jp/')"
                ></v-img>
                
              </v-col>
              <v-col cols="8">
                <v-card-text>
                  <p>〒206-0804 東京都稲城市百村1623-1</p>
                  <p>TEL : 042-378-5999  FAX : 042-378-5998</p>
                  <p>E-Mail : sales.sysdev@cdex.co.jp</p>
                  <p>URL : https://www.cdex.co.jp</p>
                  <p>※ご購入希望の場合は、弊社営業担当へお問い合わせください。</p>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- 右边列：租赁公司 -->
        <v-col cols="12" md="6">
          <v-card class="mx-auto mb-6" height="100%">
            <v-card-title class="font-weight-bold">レンタルのお問い合わせ</v-card-title>
            <v-row>
              <v-col cols="4">
                <v-img src="../public/main_page/company/nishio.png"
                  width="200px"
                  height="100px"
                  contain
                  @click="handleClick('https://www.nishio-rent.co.jp/')"
                ></v-img>
              </v-col>
              <v-col cols="8">
                <v-card-text>
                  <p>西尾レントオール株式会社 建設DX営業推進部 本部 担当：中野 貴紀</p>
                  <p>TEL : 080-5784-9361  E-Mail : takanori.nakano@nishio-rent.co.jp</p>
                </v-card-text>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-img src="../public/main_page/company/aktio.png"
                  width="200px"
                  height="100px"
                  contain
                  @click="handleClick('https://www.aktio.co.jp/')"
                ></v-img>
              </v-col>
              <v-col cols="8">
                <v-card-text>
                  <p>株式会社アクティオ 営業本部 レンタルDX営業部 担当：佐々木 義人</p>
                  <p>TEL : 03-6854-1414  E-Mail : sasaki-yoshito@aktio.co.jp</p>
                </v-card-text>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-img src="../public/main_page/company/asahikizai.png"
                  width="200px"
                  height="100px"
                  contain
                   @click="handleClick('https://asahikizai.com/')"
                ></v-img>
              </v-col>
              <v-col cols="8">
                <v-card-text>
                  <p>朝日機材株式会社 本店 営業第二部 設備仮設課 担当：吉田 唯哉</p>
                  <p>TEL : 03-6774-7523  E-Mail : yuya.yoshida@asahikizai.co.jp</p>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- フッター -->
    <v-footer color="indigo darken-2" dark padless>
      <v-col class="text-center white--text py-4">
        <div>&copy; 2024 株式会社シーデックス</div>
        <div>すべての権利を保有</div>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import Sample from "./sample.vue";

export default {
  name: 'EnhancedProductPage',
  components: {
    Sample
  },
  data() {
    return {
      sample_page: false,
      drawer:false,


      carouselImages1: [
        {
          src: require('../public/main_page/new5.mp4'),
          title: 'スマート管理で効率化',
          subtitle: '管理コスト削減と作業効率の向上を実現します',
          type: 'video/mp4', 
        },
        
      ],


      carouselImages: [
        {
          src: require('../public/main_page/new1.mp4'),
          title: 'スマート管理で効率化',
          subtitle: '管理コスト削減と作業効率の向上を実現します',
          type: 'video/mp4', 
        },
        {
          src: require('../public/main_page/new2.mp4'),
          title: 'フロア情報取得',
          subtitle: 'フロア情報を即時に取得し、探す手間を削減します',
          type: 'video/mp4', 
        },
        {
          src: require('../public/main_page/new4.mp4'),
          title: '稼働情報で運用最適化',
          subtitle: '稼働状況を把握し、運用コストを削減します',
          type: 'video/mp4', 
        },
      ],
      features: [
        {
          image: require('../public/main_page/work_car.webp'),
          title: '独自のセンシング技術',
          description: 'ビル内で稼働する作業車のフロア位置を正確に認識します。',
        },
        {
          image: require('../public/main_page/signal.webp'),
          title: 'リアルタイム通信',
          description: 'ゲートウェイ不要の通信方式でスムーズなデータ送信を実現。',
        },
        {
          image: require('../public/main_page/battery.webp'),
          title: '長寿命センサー',
          description: '低消費電力のセンサーで、メンテナンスの手間を削減します。',
        },
        {
          image: require('../public/main_page/pc.webp'),
          title: 'クラウド管理',
          description: '端末やOSを選ばず、どこからでもアクセス可能なクラウド管理による見える化を実現。',
        },
        {
          image: require('../public/main_page/move.webp'),
          title: '稼働状況表示',
          description: '作業車の動作状態を検知して、一定期間の稼働状況を表示し、作業の効率化を支援します。',
        },
        {
          image: require('../public/main_page/floor.webp'),
          title: 'フロア情報取得',
          description: '作業車のフロア位置を正確に取得し、効率的な作業の管理を可能にします。',
        },
      ],
      specs: [
        { title: '通信周波数帯', value: '920MHz' },
        { title: '使用可能電池', value: '単三乾電池2本' },
        { title: '最大送信距離', value: '10km（使用環境による）' },
        { title: '内蔵センサー', value: 'フロア判定、稼働状態、電池残量' },
        { title: '外形寸法', value: 'W:76×D:121.9×H:36.5mm / 220g' },
      ],
      testimonials: [
        {
          title: '高評価',
          content: 'このシステムのおかげで、作業効率が大幅に改善されました。非常に満足しています！',
          author: '〇〇工業',
        },
        {
          title: 'コスト削減',
          content: '管理コストが予想以上に減少し、業務の効率化にもつながっています。',
          author: '△△産業',
        },
        {
          title: '導入が簡単',
          content: '導入が非常に簡単で、すぐに運用を開始できました。サポートも素晴らしいです。',
          author: '□□機器',
        },
      ],
    };
  },
  methods:{
    handleClick(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
};
</script>

<style scoped>
/* 全局样式 */
.text-center {
  text-align: center;
}

.mx-auto {
  margin: 0 auto;
}

/* 导航栏样式 */
.v-app-bar {
  font-family: 'Roboto', sans-serif;
}

/* 轮播图文字阴影 */
.v-carousel-item h1,
.v-carousel-item h2 {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}


/* 自定义视频样式 */
.carousel-video {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持视频比例并覆盖整个容器 */
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1; /* 确保视频在文字下方 */
}

/* 确保轮播容器相对定位 */
.v-carousel-item {
  position: relative;
}


/* 产品特点卡片悬停效果 */
.v-card {
  transition: all 0.3s ease;
}

/* 页脚样式 */
.v-footer {
  font-size: 14px;
}

/* 按钮样式 */
.v-btn {
  border-radius: 25px;
}
</style>
